import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getAppName } from '@rsos/utils/metaTags';

const feAppName = getAppName();

/**
 * Create a logged-in user object used for TalkJS authentication.
 * @returns loggedInUser object
 * @param {String} role - name of the user's role.
 */
const useLoggedInUser = role => {
  const profile = useSelector(state => state.sinatra.user.profile);

  const currentPSAPDisplayName = useSelector(
    state => state.psaps.currentPSAP.display_name,
  );

  const loggedInUser = useMemo(() => {
    const {
      id = '',
      first_name = '',
      last_name = '',
      email = null,
      talkjs_signature = '',
    } = profile;

    return {
      id: id ? parseInt(id) : '',
      name: `${first_name} ${last_name}`.trim(),
      email: email,
      signature: talkjs_signature,
      custom: {
        org_name: currentPSAPDisplayName || '',
        feAppName,
      },
      ...(role ? { role } : {}),
    };
  }, [currentPSAPDisplayName, profile, role]);

  return loggedInUser;
};

export default useLoggedInUser;
